import { createContext } from "react";
const ChatMessagesContext = createContext({});
export { ChatMessagesContext };
